<template>
    <div class="cooperation">
        <header-common @popupHandle="popupHandle" :isFixed="isFixed"></header-common>
        <div class="main-content" style="min-height: 500px;">
             <div class="main-content-box">
                <div class="box">
                <div class="partent">商务合作</div>
                <div class="content-box-title">期待您的加入</div>
                <div class="content-box-span">联系电话：18068825213</div>
                </div>
            </div>
            <div class="article">
                <span>
            "我们怀着真诚和认真的态度对待每一份合作伙伴的申请，当我们需要更多的时间和您沟通时，请给予支持。因为高质量的伙伴体系对我们彼此都非常的重要，收到您的申请表后，我们将于两个工作日内与您联系。再次感谢您的支持，如有任何关于我们合作伙伴计划的问题，欢迎您通过sales@njinst.com与我们联系。"
            </span>
            </div>
            <div class="main-body">
        <div class="register-form">
        <div class="form-item" v-for="(formItem,index) in formItems" :key="formItem.blur">
          <div class="form-item-name showhide">
            {{formItem.name}}
            <span class="spanshowhide">*</span>
          </div>
          <div class="form-item-info">
            <img :src="focusIndex==index?formItem.focus:formItem.blur" alt />
            <input
              class="form-item-text showpc"
              type="text"
              v-model="registerForm[formItem.prop]"
              :placeholder="formItem.placeholder"
              @focus="focusIndex=index;"
              @blur="focusIndex=-1"
              @input="validateInput(formItem.prop,$event)"
            />
               <input
              class="form-item-text showrem"
              type="text"
              v-model="registerForm[formItem.prop]"
              :placeholder="formItem.name"
              @focus="focusIndex=index;"
              @blur="focusIndex=-1"
              @input="validateInput(formItem.prop,$event)"
            />
            <span class="form-item-tip">{{formItem.tip}}</span>
          </div>
        </div>
        <div class="form-item">
          <div class="sign btn point" @click="submitRegister">提交</div>
        </div>
      </div>
      </div>
        <div class="mask" :class="{shown:showSuccess}">
      <div class="success">
        <img src="../../assets/images/register/success_bg.png" alt />
        <div class="success-title">提交成功</div>
        <p class="success-content">感谢您的配合，我们将于</p>
        <p>1-2个工作日内与您联系</p>
        <div class="btn point done" @click="known">知道了</div>
      </div>
    </div>
     <div class="alert" :class="{shown:errorMsg.show}">
      {{errorMsg.msg}}
      <span class="alert-close point" @click="errorMsg.show=false">x</span>
    </div>
        </div>
        <footer-common :isShowTopBtn="isShowTopBtn"> </footer-common>
    </div>
</template>

<script>
import headerCommon from '../common/headerCommon';
import footerCommon from '../common/footerCommon';
export default {
    name: "cooperation",
    data () {
        return {
            isShowTopBtn: false,
            isFixed: false,
            registerForm: {
                unitName: "",
                userName: "",
                phoneNumber: "",
                position: ""
            },
            errorMsg: {
                show: false,
                msg: ""
            },
            showSuccess: false,
            focusIndex: -1,
            formItems: [
                {
                    prop: "unitName",
                    type: "text",
                    name: "单位名称",
                    required: true,
                    blur: require("../../assets/images/register/unit.png"),
                    focus: require("../../assets/images/register/unit_focus.png"),
                    tip: "填写您的单位名称",
                    placeholder: "请输入单位名称"
                },
                {
                    prop: "userName",
                    type: "text",
                    name: "姓名",
                    required: true,
                    blur: require("../../assets/images/register/user.png"),
                    focus: require("../../assets/images/register/user_focus.png"),
                    tip: "希望我们如何称呼您？",
                    placeholder: "请输入姓名"
                },
                {
                    prop: "position",
                    type: "text",
                    name: "职务",
                    required: true,
                    blur: require("../../assets/images/register/job.png"),
                    focus: require("../../assets/images/register/job_focus.png"),
                    tip: "提前了解您的业务特征，安排合适的顾问",
                    placeholder: "请输入职务"
                },
                {
                    prop: "phoneNumber",
                    type: "number",
                    name: "手机号码",
                    required: true,
                    blur: require("../../assets/images/register/phone.png"),
                    focus: require("../../assets/images/register/phone_focus.png"),
                    tip: "顾问将于1-2个工作日内致电您。",
                    placeholder: "请输入手机号码"
                }
            ]
        };
    },
    components: {
        headerCommon,
        footerCommon
    },
    methods: {
        handleScroll () {
            let that = this;
            this.$nextTick(()=>{
                // 设备/屏幕高度
                let scrollTop = document.documentElement.scrollTop; // div 到头部的距离
                if (scrollTop >0) {
                    that.isFixed = true;
                    that.isShowTopBtn = true;
                } else {
                    that.isFixed = false;
                    that.isShowTopBtn = false;
                }
            });
        },
        validatePass(index) {
            console.log(index);
            this.focusIndex = -1;
        },
        validateInput(prop, e) {
            // console.log(e.data)
            if (prop === "phoneNumber") {
                if (e.data) {
                    this.registerForm.phoneNumber = this.registerForm.phoneNumber.replace(
                        /[^\d]/g,
                        ""
                    );
                }
                this.registerForm.phoneNumber = this.registerForm.phoneNumber.replace(
                    /[^\d]/g,
                    ""
                );
            }
        },
        submitRegister() {
            if (this.registerForm.unitName.trim() === "") {
                // console.log("单位错了");
                this.errorShow("请输入单位名称");
                return;
            }
            if (this.registerForm.unitName.trim().length > 40) {
                console.log("单位错了");
                this.errorShow("单位名称最多输入40个字符，请重新输入");
                return;
            }
            if (this.registerForm.userName.trim() === "") {
                // console.log("错了");
                this.errorShow("请输入姓名");
                return;
            }

            if (this.registerForm.userName.trim().length > 30) {
                // console.log("错了");
                this.errorShow("姓名最多输入30个字符，请重新输入");
                return;
            }
            let phoneTest = /^1[3456789]\d{9}$/;
            if (this.registerForm.phoneNumber.length === 0) {
                // console.log("电话错了");
                this.errorShow("请输入手机号码");
                return;
            }

            if (this.registerForm.phoneNumber.length !== 11 || !phoneTest.test(this.registerForm.phoneNumber)) {
                // console.log("电话错了");
                this.errorShow("手机号码填写有误，请重新输入");
                return;
            }
            let that = this;
            this.registerForm.type = "COOPERATION";
            this.$axios
                .post("/customer/doApply", this.registerForm)
                .then(function(res) {
                    if (Number(res.data.code) === 0) {
                        that.showSuccess = true;
                    }
                })
                .catch(function(error) {
                    console.log(error);
                });
            console.log(11111);
        },
        errorShow(msg) {
            this.errorMsg.show = true;
            this.errorMsg.msg = msg;
            setTimeout(() => {
                this.errorMsg.show = false;
            }, 2500);
        },
        known() {
            this.showSuccess = false;
            this.registerForm.unitName = "";
            this.registerForm.userName = "";
            this.registerForm.phoneNumber = "";
            this.registerForm.position = "";
        },
        popupHandle (){}
    },
    mounted() {
        window.addEventListener('scroll',this.handleScroll);
    }
};
</script>

<style scoped lang="less">

.register-form .form-item {
  position: relative;
  font-size: 0;
}

.form-item .form-item-info {
  display: inline-block;
}

.form-item .form-item-name {
  width: 140px;
  text-align: right;
  margin-right: 20px;
  font-size: 18px;
}

.form-item .form-item-name span {
  color: #ff0000;
}



.form-item .form-item-info img {
  position: absolute;
  left: 19px;
  top: 14px;
}

.form-item .form-item-info .form-item-tip {
  font-size: 14px;
  line-height: 1;
  color: #aaa;
  position: absolute;
  bottom: 20px;
  left: 0;
}

.form-item .form-item-info input {
  width: 100%;
  height: 52px;
  border-radius: 10px;
  background-color: #f1f1f1;
  border: none;
  outline: none;
  padding-left: 53px;
  font-size: 1rem;
  color: #333;
  box-sizing: border-box;
  border: 1px solid transparent;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

input[type="number"] {
  -moz-appearance: textfield;
}

.form-item .form-item-info input:focus {
  border-color: #00a0e9;
  box-shadow: 0 0 3px #00a0e9;
}

input::placeholder {
  color: #a9b3b9;
}

:-ms-input-placeholder.form-item-text {
  color: #a9b3b9!important;
}
.login {
  display: flex;
  width: 100%;
  height: 126px;
  align-items: center;
  background-color: #f5fbff;
  border: 1px solid #d2eeff;
  margin-top: 40px;
  padding-left: 180px;
  font-size: 18px;
  color: #333;
  box-sizing: border-box;
}

.login .login-btn {
  height: 46px;
  line-height: 46px;
  width: 80px;
  margin-left: 10px;
    margin-right: 15px;
  /* background-color: #00a0e9; */
  border-radius: 5px;
  color: #fff;
  text-align: center;
}

.point {
  cursor: pointer;
}

.btn {
  background-color: #00a0e9;
}
.btn:hover {
  background-color: #4a97bb;
}

.mask {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 1000;
  padding-top: 182px;
  display: none;
}

.mask.shown {
  display: block;
}

.mask .success {
  height: 340px;
  width: 384px;
  background-color: #fff;
  border-radius: 10px;
  margin: 0 auto;
  position: relative;
  margin-top: 80px;
}
.mask .success img {
  margin: 0 auto;
  margin-top: -80px;
}

.mask .success .success-title {
  margin-top: 18px;
  line-height: 1;
  margin-bottom: 3px;
  font-size: 24px;
  color: #333;
}

.mask .success p {
  font-size: 14px;
  color: #aaa;
  line-height: 28px;
}

.mask .success .done {
  height: 51px;
  width: 327px;
  line-height: 51px;
  color: #fff;
  border-radius: 25px;
  margin: 23px auto;
}

.alert {
  height: 60px;
  background-color: rgba(247, 60, 60, 0.6);
  // width: 600px;
  position: fixed;
  top: -70px;
  border: 1px solid #ddd;
  border-radius: 10px;
  left: 50%;
  transform: translateX(-50%);
  transition: all .3s linear;
  font-size: 18px;
  /* font-weight:bold; */
  line-height: 60px;
  color: #fff;
  z-index: 120;
}

.alert.shown {
  top: 70px;
}

.alert .alert-close {
  position: absolute;
  display: inline-block;
  height: 100%;
  padding: 0 20px;
  right: 0;
}
.alert .alert-close:hover {
  background-color: rgba(247, 60, 60, 0.3);
}

.cooperation{
    .main-content{
        padding-top: 60px;
    }
  @media screen and (min-width: 1200px) {
    .showpc{
      display: inline-block;
    }
    .showrem{
       display:none;
    }
    .alert {
      width: 600px;
    }
    .sign {
  width: 420px;
  height: 52px;
  line-height: 56px;
  border-radius: 10px;
  margin-left: 164px;
  margin-top: 8px;
  /* background-color: #00a0e9; */
  font-size: 20px;
  color: #fff;
  text-align: center;
}
    .form-item .form-item-info {
  width: 420px;
  position: relative;
  padding-bottom: 44px;
}
    .main-body {
  width:50%;
  text-align: left;
  margin: 0 auto 50px auto;
  /* padding-top: 182px; */
}
    .main-content{
      margin: 0 auto;
   .main-content-box{
      width: 100%;
      height: 435px;
      background: url(../../assets/images/webSite/cooperation_banner.png)no-repeat;
      position: relative;
      background-size: 100% 100%;
 .box{
  //  text-align: left;
    width: 100%;
    position: absolute;
    top:132px;
    right: 438px;
    // left:431px;
   .partent{
     font-size: 36px;
     line-height: 60px;
     color: #ffffff;
     font-family:"MicrosoftYaHei-Bold";
     font-weight: 900;
   }
   .content-box-title{
         margin-left: -40px;
       font-size: 16px;
       color: #ffffff;
        font-family: "MicrosoftYaHei";
        line-height:42px
   }
   .content-box-span{
     margin-left: 45px;
       font-size: 16px;
       color: #ffffff;
        font-family: "MicrosoftYaHei";
        line-height:20px
   }
 }
}
.article{
   margin:40px auto;
   color:#7e7e7e;
    width: 1060px;
    text-align: left;
  span{
    display: inline-block;
    width:100%;
    font-size: 14px;
  }

}
.showhide{
  display:inline-block;
}
.spanshowhide{
  display: inline-block;
}
    }
  }
  @media screen and (max-width:1199px) {
 .showpc{
      display:none;
    }
    .showrem{
       display: inline-block;
    }
     .alert {
      width: 90%;
    }
    .sign {
      width: 90%;
      height: 52px;
      line-height: 56px;
      border-radius: 40px;
      margin-left: 164px;
      margin-top: 8px;
      /* background-color: #00a0e9; */
      font-size: 20px;
      color: #fff;
      text-align: center;
    }
    .form-item .form-item-info {
  width: 90%;
  position: relative;
  padding-bottom: 44px;
}
    .main-content{
      margin: 0 auto;
   .main-content-box{
      width: 100%;
      height: 375px;
      background: url(../../assets/images/webSite/cooperation.png)no-repeat;
      position: relative;
      background-size:  100%  100%;
      overflow: hidden;
 .box{
  //  text-align: left;
  //  position: absolute;
  //  top:132px;
  //  left:150px;
  margin:120px auto  0 auto;
   .partent{
     font-size: 2.5rem;
     line-height: 64px;
     color: #ffffff;
     font-family:"MicrosoftYaHei-Bold";
   }
   .content-box-title{
       font-size: 1.25rem;
       color: #ffffff;
        font-family: "MicrosoftYaHei";
        line-height:32px
   }
   .content-box-span{
       font-size: 1.1rem;
       color: #ffffff;
        font-family: "MicrosoftYaHei";
        line-height:32px
   }
 }
}
.article{
   margin:30px auto 30px auto ;
   color:#7e7e7e;
  span{
    display: inline-block;
    width:90%;
    font-size: 1rem;
      text-indent: 24px;
      text-align: left;
  }

}
.main-body {
  // width:100%;
  text-align:center;
  margin: 0 auto 40px auto;
  /* padding-top: 182px; */
}
.showhide{
  display: none;
}
.spanshowhide{
  display: none;
}
    }
.btn{
    margin: 0 auto;
  }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/cooperation/cooperation.vue